import { css } from '@emotion/core';
var _ref = {
  name: "1l0z8uk",
  styles: "flex-direction:row;"
};
var _ref2 = {
  name: "1mcrfa7",
  styles: "max-width:33%;"
};
var _ref3 = {
  name: "3ra2f4",
  styles: "display:flex;gap:16px;flex-direction:row;"
};
export default (_ref4 => {
  let layout = _ref4.layout;
  const articleWrapper = /*#__PURE__*/css("display:flex;flex-direction:column;gap:16px;", layout === 'row' && _ref);
  const card = layout === 'row' && _ref2;
  const secondRow = _ref3;
  return {
    articleWrapper,
    card,
    secondRow
  };
});